import { h } from 'preact'
import { useState } from 'preact/hooks'
import initializeForm from '../utilities/initializeForm'

import { formFields, formSchema } from './config'

import FormInput from '../elements/FormInput'

import sharedStyles from '../sharedStyles.module.scss'

import BarChart from '../../charts/BarChart'
import ChartContainer from '../../charts/ChartContainer/ChartContainer'

function calculate({ proceeds, annualNeeds, rateOfReturn }) {
  const assets = Number(proceeds)
  const income = Number(annualNeeds)
  const interestEarned = (assets * Number(rateOfReturn)) / 100

  const expectedSavings = (
    (Math.log(1 - ((Number(rateOfReturn) / 100) * assets) / income) * -1) /
    Math.log(1 + Number(rateOfReturn) / 100)
  ).toFixed(1)

  const yearlyAmount = assets / expectedSavings

  const totalSavings = Math.round(assets, 1)

  if (interestEarned < income) {
    const data = []
    let x = totalSavings - yearlyAmount
    let year = 1
    while (x > 0) {
      data.push({
        year,
        value: x.toFixed(2),
      })
      year += 1
      x = x - yearlyAmount
    }
    return {
      data,
    }
  } else {
    return {
      message: 'Your interest generated exceeds your yearly income.',
    }
  }
}

export default function InsuranceProceedsForm({ formName }) {
  const [view, setView] = useState('form')
  const [message, setMessage] = useState(null)
  const [data, setData] = useState(null)
  const { formValues, formErrors, handleInputChange, validateForm, resetForm } =
    initializeForm({
      initialValues: {
        proceeds: '',
        annualNeeds: '',
        rateOfReturn: '3',
      },
      formSchema,
    })

  function submit() {
    validateForm().then(validFormData => {
      calculate(validFormData)

      const result = calculate(validFormData)

      setView('results')
      if (result.message) {
        setMessage(result.message)
      }
      if (result.data) {
        setData(result.data)
      }
    })
  }

  function renderMessage() {
    if (message) {
      return <p>{message}</p>
    }
    if (data) {
      return (
        <p>
          The proceeds of your life insurance policy will last for{' '}
          {data?.length} years.
        </p>
      )
    }
    return null
  }

  if (view === 'results') {
    return (
      <ChartContainer
        edit={() => {
          setView('form')
          setData(null)
          setMessage(null)
        }}
        reset={() => {
          setView('form')
          resetForm()
          setData(null)
          setMessage(null)
        }}
        message={renderMessage()}
      >
        {data && <BarChart data={data} />}
      </ChartContainer>
    )
  }

  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        submit()
      }}
      className={sharedStyles.Form}
    >
      {Object.entries(formFields).map(([key, input]) => {
        const id = `${formName}-${key}`
        return (
          <FormInput
            key={id}
            id={id}
            identifier={key}
            input={input}
            error={formErrors?.[key]}
            value={formValues?.[key]}
            handleInputChange={handleInputChange}
          />
        )
      })}
      <div className={sharedStyles.SubmitContainer}>
        <button type="submit" className="button dark">
          Calculate
        </button>
      </div>
    </form>
  )
}
